/**
 * WHERE "TABLES" GOES BACK TO (founder, 2026-10-06: "if I open a table, switch
 * to the kitchen and come back to tables, I should land on that table, not the
 * table list").
 *
 * The register's Kitchen tab carries the till screen it was pressed on in
 * `?back=` on the floor's kitchen view, and the floor's Tables tab returns
 * there instead of to the list. It is a URL value, so it is read as untrusted:
 * only another screen of this locale's till is honoured, never an external
 * address or anything that could become one.
 */
export const TILL_RETURN_PARAM = "back";

export function tillReturnPath(raw: string | null, locale: string): string | null {
  if (!raw) return null;
  if (!raw.startsWith(`/${locale}/pos/`)) return null;
  if (raw.includes("//") || raw.includes("..") || raw.includes("\\") || /[\s:]/.test(raw)) {
    return null;
  }
  return raw;
}
